
export default {
  props: {
    antiTippingBanner: { type: Object, default: () => {} },
  },

  computed: {
    bannerImgProps() {
      const img = this.$device.isMobile
        ? this.antiTippingBanner?.mobile
        : this.antiTippingBanner?.desktop;

      return {
        src: img?.url,
        alt: img?.alt,
        width: img?.dimensions?.width,
        ...this.getImageDimensions(img?.dimensions, 800),
      };
    },
  },
};
